<template>
    <div class="pb-5 sm:pb-0">
        <h1 class="text-3xl font-semibold text-taupe-900">Admin</h1>
        <div class="mt-4 sm:mt-5">
            <!-- Dropdown menu on small screens -->
            <div class="sm:hidden">
                <label for="current-tab" class="sr-only">Select a tab</label>
                <select
                    id="current-tab"
                    @change="navigate"
                    name="current-tab"
                    class="block w-full rounded-md border-taupe-300 py-2 pl-3 pr-10 text-base focus:border-sky-500 focus:outline-hidden focus:ring-sky-500 sm:text-sm"
                >
                    <option :selected="isProjects" value="AdminProjectsScreen">
                        Projects
                    </option>
                    <option
                        v-if="isAdmin"
                        :selected="isUsers"
                        value="AdminUsersScreen"
                    >
                        Users
                    </option>
                    <option
                        v-if="isAdmin"
                        :selected="isTeams"
                        value="AdminTeamsScreen"
                    >
                        Teams
                    </option>
                    <option
                        v-if="isAdmin"
                        :selected="isApiMcpTokens"
                        value="AdminApiMcpTokensScreen"
                    >
                        API/MCP Tokens
                    </option>
                    <option
                        v-if="isAdmin"
                        :selected="isBilling"
                        value="AdminBillingScreen"
                    >
                        Billing
                    </option>
                    <option
                        v-if="isAdmin"
                        :selected="isAccount"
                        value="AdminAccountScreen"
                    >
                        Account
                    </option>
                </select>
            </div>
            <!-- Tabs at small breakpoint and up -->
            <div class="hidden sm:block">
                <zen-tab-list>
                    <zen-tab
                        :active="isProjects"
                        :to="{ name: 'AdminProjectsScreen' }"
                        >Projects</zen-tab
                    >
                    <zen-tab
                        v-if="isAdmin"
                        :active="isUsers"
                        :to="{ name: 'AdminUsersScreen' }"
                        >Users</zen-tab
                    >
                    <zen-tab
                        v-if="isAdmin"
                        :active="isTeams"
                        :to="{ name: 'AdminTeamsScreen' }"
                        >Teams</zen-tab
                    >
                    <zen-tab
                        v-if="isAdmin"
                        :active="isApiMcpTokens"
                        :to="{ name: 'AdminApiMcpTokensScreen' }"
                        >API/MCP Tokens</zen-tab
                    >
                    <zen-tab
                        v-if="isAdmin"
                        :active="isBilling"
                        :to="{ name: 'AdminBillingScreen' }"
                        >Billing</zen-tab
                    >
                    <zen-tab
                        v-if="isAdmin"
                        :active="isAccount"
                        :to="{ name: 'AdminAccountScreen' }"
                        >Account</zen-tab
                    >
                </zen-tab-list>
            </div>
        </div>
    </div>
</template>

<script>
import { usePermissions } from '@/composables/usePermissions'

export default {
    name: 'AdminHeaderTabs',
    setup() {
        const { isAdmin } = usePermissions()
        return { isAdmin }
    },
    computed: {
        isAccount() {
            return this.current == 'account'
        },
        isBilling() {
            return this.current == 'billing'
        },
        isProjects() {
            return this.current == 'projects'
        },
        isUsers() {
            return this.current == 'users'
        },
        isTeams() {
            return this.current == 'teams'
        },
        isApiMcpTokens() {
            return this.current == 'api-mcp-tokens'
        },
    },
    methods: {
        async navigate(e) {
            await this.$router.push({ name: e.target.value })
        },
    },
    props: ['current'],
}
</script>
